



















































































import { Component, Vue, Prop, Provide, Watch, Inject, Mixins } from 'vue-property-decorator'
import { APagination } from './../../components'
import { AInput, AButton, AIcon, Ranger, NoResult, PaperItem } from '@/components'
import DownloadModal from './components/DownloadModal.vue'
import { paperList, paperDoc, otherAccounts, paperDocS2, getSourceAddress } from './models/api'
import { loadFromLocal } from '@/utils/local'
import { getUrlParams, windowOpen } from '@/utils/urlUtils'
import { sa } from '@/utils/sa'
import Download from './mixins/download'
import ScrollToTop from './mixins/scrollToTop'
import LessInfo from '@/components/LessInfo'
const position = '试卷列表页'

@Component({
  components: {
    AInput,
    AButton,
    AIcon,
    PaperItem,
    Ranger,
    DownloadModal,
    NoResult,
    APagination,
    LessInfo
  }
})
export default class PaperList extends Mixins(Download, ScrollToTop) {
  public paperId = ''
  public visible = false
  public testModal = false
  public netData = []
  public currentTitle = ''
  public contentData = []
  public page = 1
  public perPage = 10
  public sortType = 1 // 1 综合排序  2 时间排序 默认1
  public total = 0
  public loading = false
  public currentPaper: any = {}
  public rn: string = ''
  public youDian = {}
  public currentUrl = ''
  // public loadingModal: boolean = false
  public clean = false
  public typed = false // 是否为精排卷，默认 否 后端对应参数 1为 精
  public famousPaper = false // 是否为名校试卷
  public page_total = 0
  public checkUserOk = false // 判断usertoken接口调用成功标识

  /**
   * mounted
   */
  public mounted() {
    if (this.keyword) {
      this.currentTitle = this.keyword + ''
    }
    if (this.$route.query.famous) {
      this.famousPaper = true
    }
    // 期末考试 默认时间排序、默认选中精排
    if (this.getSortWay == '5') {
      this.sortType = 2
      this.typed = true
    }
  }
  // computed
  private get userInfo() {
    return this.$store.state.user_info
  }
  public get keyword() {
    return this.$route.query.keyword
  }
  public get subject() {
    return this.$store.state.subject
  }
  public get getFilters() {
    return this.$store.state.filters
  }
  public get switchTemplate() {
    if (this.contentData.length > 0) {
      return 1
    } else {
      return 2
    }
  }
  public get userName() {
    return this.$store.state.user_info && this.$store.state.user_info.nickname
  }
  public get grades() {
    return this.$store.state.grades
  }
  private get banner_state() {
    return this.$store.state.banner
  }
  private get subjectId() {
    return this.$route.query.subject_id
  }
  private get platformlogin() {
    return this.$store.state.platformlogin
  }
  // 期末考试
  private get getSortWay() {
    return this.$route.query.sort_way
  }

  @Watch('platformlogin', { deep: true })
  onPlatformlogin() {
    this.checkUserOk = true
  }
  @Watch('subject', { immediate: true, deep: true })
  onSubjectChange(val, old) {
    if (old && val.value === old.value) return
    this.reset()
  }
  @Watch('getFilters', { deep: true })
  onFiltersChange(val, old) {
    if (old) {
      if (
        old.grade === val.grade &&
        old.paper_type === val.paper_type &&
        old.region_code === val.region_code &&
        old.year === val.year &&
        val.reset
      ) {
        return
      }
    }
    this.page = 1
    this.getList()
  }
  @Watch('currentTitle')
  onCurrentTitleChange(val) {
    if (val === '') {
      this.page = 1
      this.getList()
    }
  }
  @Watch('userInfo', { deep: true })
  onUserChange(val, old) {
    if (old && val && val.nickname === old.nickname) return
    if (val && val.nickname) {
      this.page = 1
      this.getList()
    }
  }
  @Watch('banner_state')
  onClickBanner(val) {
    // 广告位点击_题库_首页
    window['sensors'].track('TIKU_homepage_clickAdvert', {
      AdvertURL: '/assessment/lib'
    })
    if (this.userInfo && this.userInfo.nickname) {
      setTimeout(() => {
        this.$router.push({ path: '/assessment/lib' })
      }, 100)
    } else {
      setTimeout(() => {
        window.location.reload()
      }, 100)
    }
  }
  public clearSearchInput() {
    this.currentTitle = ''
    this.page = 1
    this.getList()
  }
  public downloadInfoChange(val) {
    if (this.visible) {
      // this.getPaperDoc(this.currentPaper.id, val)
    }
  }
  public onTestCancel() {
    this.testModal = false
  }
  public reset() {
    this.$store.commit('SET_FILTERS', {
      grade: 0,
      paper_type: 0,
      region_code: 0,
      year: 0,
      reset: true,
      city: 0,
      district: 0,
      cityArray: [],
      districtArray: []
    })
    this.$store.commit('SET_RESET', true)
    this.clean = !this.clean
    this.currentTitle = ''
    this.contentData = []
    this.page = 1
    // 新增重置
    this.typed = false
    this.famousPaper = false
    this.sortType = 1
  }
  /**
   * clickDownload
   */
  public clickDownload(val: any) {
    this.currentPaper = val
    if (!this.userName) {
      this.$store.commit('SET_LOGINMODAL', true)
      return
    }

    let param = val
    if (val.is_excellent) {
      window['sensors'].track(
        'Download_buttonClick',
        Object.assign(
          { paper_id: val.paper_id, name: val.name, position, paper_form: '精排卷' },
          param
        )
      )
    } else {
      window['sensors'].track(
        'Download_buttonClick',
        Object.assign({ paper_id: val.paper_id, name: val.name, position, paper_form: '非精排卷' })
      )
    }

    this.getPaperDoc(val.paper_id, param)
  }
  /**
   * cancelModal
   */
  public cancelModal(val: any) {
    this.visible = false
    this.currentPaper = {}
  }
  /**
   * onSearch
   */
  public onSearch() {
    this.page = 1
    this.getList()

    window['sensors'].track('Examinationpage_searchButtonClick', {
      keyword: this.currentTitle || ''
    })
  }
  public onPageChange(val) {
    this.page = val
    this.getList()
    this.scrollTo(0) // 滚动到顶
    window['sensors'].track('Examinationpage_buttonClick', {
      button_1: 'page',
      button_1_name: '页码',
      button_2: String(this.page),
      button_2_name: String(this.page),
      page: String(this.page)
    })
  }
  // 精排卷筛选
  onVersionChange(e) {
    this.typed = e.target.checked
    // 筛选
    this.page = 1
    this.getList()
    window['sensors'].track('Examinationpage_buttonClick', {
      button_1: 'is_excellent',
      button_1_name: '精排卷',
      button_2: String(this.typed),
      button_2_name: this.typed ? '是' : '否'
    })
  }
  // 名校试卷筛选
  onFamousChange(e) {
    this.famousPaper = e.target.checked
    // 筛选
    this.page = 1
    this.getList()

    window['sensors'].track('Examinationpage_buttonClick', {
      button_1: 'is_famous_school',
      button_1_name: '名校试卷',
      button_2: String(this.famousPaper),
      button_2_name: this.famousPaper ? '是' : '否'
    })
  }
  onClickRanger(val) {
    this.sortType = val
    this.page = 1
    this.getList()

    window['sensors'].track('Examinationpage_buttonClick', {
      button_1: 'sort_type',
      button_1_name: '排序',
      button_2: this.sortType,
      button_2_name: this.sortType === 1 ? '综合排序' : '时间排序'
    })
  }
  //
  public async getList() {
    let obj = Object.assign({}, this.getFilters, {
      subject_id: ~~this.subject.value,
      keyword: this.currentTitle,
      page: this.page,
      per_page: this.perPage,
      is_famous_school: this.famousPaper,
      sort_type: this.sortType
    })
    if (!this.checkUserOk) return
    if (this.rn) {
      obj.rn = this.rn
    }
    if (!~~this.subject.value) {
      return
    }
    if (!this.loading) {
      this.loading = true
    }
    // 是否为精排卷
    if (this.typed) {
      obj.is_excellent = true
    } else {
      obj.is_excellent = false
    }
    try {
      const { data, total }: any = await paperList(obj)
      if (this.loading) {
        this.loading = false
      }
      if (data && data.length > 0) {
        this.contentData = data
        this.total = total
        if (this.total >= 100 * this.perPage) {
          this.page_total = 100 * this.perPage
        } else {
          this.page_total = this.total
        }
      } else {
        this.contentData = []
        this.total = 0
      }
      // 点击打点
      let param = Object.assign({}, obj, { total: total })
      let trackParam = {
        city: param.city || '',
        district: param.district || '',
        grade: param.grade,
        is_excellent: param.is_excellent,
        is_famous_school: param.is_famous_school,
        keyword: param.keyword || '',
        page: param.page,
        paper_type: param.paper_type,
        paper_type_name: param.paper_type_name || '',
        per_page: param.per_page,
        rating: param.rating,
        region_code: param.region_code,
        region_name: param.region_name,
        sort_type: param.sort_type,
        subject_id: param.subject_id,
        total: param.total,
        year: param.year
      }
      Vue.nextTick(() => {
        window['sensors'].track('Examinationpage_loading', trackParam)
      })
    } catch (e) {
      if (this.loading) {
        this.loading = false
      }
      this.contentData = []
      this.total = 0
    }
  }
  public async getPaperDoc(val, obj?: any) {
    let count = 0
    let req: any = {
      subject_id: this.subject.value,
      paper_id: val
    }
    if (obj) {
      req = Object.assign({}, req, obj)
    }
    this.loadingModal = true
    try {
      const data: any = await paperDoc(req)
      if (data.error && data.error == '请登录') {
        this.visible = false
        this.$store.commit('SET_LOGINMODAL', true)
      }
      if (data.success) {
        this.getSource(data.data.task_id, count, req.subject_id, val, '')
      }
    } catch (e) {
      this.loadingModal = false
    }
  }
  public clickTellUS() {
    this.$store.commit('SET_', {})
  }
}
